import {
  OneClickNextWorkingDayActions,
  OneClickNextWorkingDayActionTypes,
} from '../actions/one-click-next-working-day.actions';

export interface OneClickNextWorkingDayState {
  nextWorkingDay: Date;
}

export const initialState: OneClickNextWorkingDayState = {
  nextWorkingDay: null,
};

export function reducer(state = initialState, action: OneClickNextWorkingDayActions): OneClickNextWorkingDayState {
  switch (action.type) {
    case OneClickNextWorkingDayActionTypes.LOAD_NEXT_WORKING_DAY: {
      return {
        ...state,
      } as OneClickNextWorkingDayState;
    }
    case OneClickNextWorkingDayActionTypes.LOAD_NEXT_WORKING_DAY_COMPLETE: {
      return {
        ...state,
        nextWorkingDay: action.payload,
      } as OneClickNextWorkingDayState;
    }
    case OneClickNextWorkingDayActionTypes.RESET: {
      return {
        ...initialState,
      };
    }
    default: {
      return state;
    }
  }
}
